export interface CandidatePrivacySettings {
  about: string;
  experience: string;
  skills: string;
  education: string;
  contact: string;
}

export interface CandidateInfo {
  _id: string;
  userId: string;
  firstName: string;
  lastName: string;
  email: string;
  type: number;
  status: string;
  refNo: string;
  isRegistered: boolean;
  createdAt: string;
  updatedAt: string;
  address: string;
  phoneNo: string | null;
  jobTitle: string;
  location: string;
  availableDate: string;
  profilePic: string;
  privacySettings: CandidatePrivacySettings;
}

export interface AppliedJobInfo {
  _id: string;
  candidateId: string;
  jobId: string;
  cv: string;
  coverLetter: string;
  viewed: boolean;
  isSkillMatchVisible: boolean;
  createdAt: string;
  updatedAt: string;
}

export interface Candidate {
  candidate: CandidateInfo;
  skillsMatched: number;
  appliedJobInfo: AppliedJobInfo;
}

export enum Tabs {
  Candidate = "Candidates List",
  JobDetails = "Job Details",
}

export type Skill = {
  _id: string;
  jobRequirementId: string;
  title: string;
  userType: number;
  type: number;
  rating: number;
  years: number;
  lastUsed: number;
  isWorkExperienceSummary: boolean;
  createdAt: string;
  updatedAt: string;
};

export type Salary = {
  min: number;
  max: number;
};

export interface Company {
  _id: string;
  name: string;
  address1: string;
  zipCode: string;
  email: string;
  createdBy: string;
  createdAt: string;
  updatedAt: string;
  refNo: string;
}

export type JobRequirement = {
  _id: string;
  title: string;
  description: string;
  location: string;
  salary: Salary;
  companyId: string;
  createdAt: string;
  createdBy: string;
  industryType: string;
  jobType: number;
  publishedDate: string;
  refNo: string;
  skills: Skill[];
  status: number;
  updatedAt: string;
  workPlaceOption: number;
  company: Company;
};
